@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/typography/typography' as *;

.dateSpan {
  @include typography-v2-body-xs;

  color: var(--text-soft);
}

.styledPriceDisplay {
  [data-price] {
    @include typography-v2-title-lg;
  }

  [data-price-currency] {
    @include typography-v2-body-xxs;
  }
}

.horizontalView {
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;

  [data-price] {
    @include typography-v2-body-sm;
  }

  [data-testid='market-status'] > span {
    margin-right: 0;
  }
}

.hidePricePercentage {
  [data-testid='price-change'] > span:last-child {
    display: none;
  }
}

.performanceOnly {
  [data-price],
  [data-price-currency] {
    display: none;
  }
}

.showDotSeparator {
  [data-testid='market-status']::before {
    content: '';
    width: 2px;
    height: 2px;
    border-radius: 50%;
    background-color: var(--icon-soft);
    display: flex;
    align-self: center;
    margin-right: 8px;
  }
}

.priceSkeleton {
  @include border-radius-r2;

  width: 120px;
  height: 20px;
}
